// Form Buttons Add Icons 
const gformButtons = document.querySelectorAll('.gform_button');

gformButtons.forEach(button => {
    const icon = document.createElement('i');
    icon.className = 'icon-arrow-down';

    button.appendChild(icon);
});

// Pass Page Title
document.addEventListener('DOMContentLoaded', function() {
  const currentPagePath = window.location.pathname; // Get the current page's path
  const currentPageSlug = currentPagePath.split('/').filter(Boolean).pop(); // Extracts the last segment (slug) of the path
  const sanitizedSlug = currentPageSlug.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, ''); // Sanitize the slug

  const previousPageSlug = localStorage.getItem('previousPageSlug');

  if (previousPageSlug) {
      const currentURL = new URL(window.location.href);
      const encodedPreviousPageSlug = encodeURIComponent(previousPageSlug);

      currentURL.searchParams.set('prev', encodedPreviousPageSlug);
      history.replaceState({ path: currentURL.href }, '', currentURL.href);
  }

  localStorage.setItem('previousPageSlug', sanitizedSlug);
});
